import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_PETITION_AI_SUMMARIES_COMBO_EXPERIMENT = defineFcm(
	'revenue_petition_ai_summaries_combo_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: {
					type: 'string',
					description: 'The name of the experiment to use for AI summaries on combo page.',
				},
				enabled: {
					type: 'boolean',
					default: false,
					description: 'Whether the localized membership ask headline is enabled on combo page.',
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
